import { useMemo } from 'react'
import { get } from 'lodash'
import { isVacationHoldActiveWithinRange } from 'utils/vacation'

export const useVacationHolds = (vacationHoldData, locationId) => {
  const vacationHolds = useMemo(() => get(vacationHoldData, 'vacationHolds', []), [vacationHoldData])

  const activeVacationHolds = useMemo(() => {
    return vacationHolds.filter(hold => {
      const isActive = get(hold, 'active', false)
      const isVacation = get(hold, 'type') === 'Vacation'
      const locations = get(hold, 'locations', [])
      const includesLocation = locations.includes(locationId)
      return isActive && isVacation && includesLocation
    })
  }, [vacationHolds, locationId])

  const isDateInVacationHold = useMemo(() => {
    return dateStr => {
      if (!dateStr || activeVacationHolds.length === 0) return false

      return activeVacationHolds.some(hold => {
        const holdStartDate = get(hold, 'startDate')
        const holdEndDate = get(hold, 'endDate')

        if (!holdStartDate) return false

        return isVacationHoldActiveWithinRange(holdStartDate, holdEndDate, dateStr)
      })
    }
  }, [activeVacationHolds])

  return { activeVacationHolds, isDateInVacationHold }
}
